import { colors } from "@elit-hair/elit-tools";
import { DateTime } from "luxon";
import { useCallback, useEffect, useMemo } from "react";
import QRCode from "react-qr-code";

import PlateComponent from "@/components/Plate";
import { groupArray } from "@/helpers/object";
import { WeTrackVehicleData } from "@/types/wetrack.types";

import { useVehiclesContext } from "../VehiclesContext";

export const PrintVehicleIds = () => {
    const { rows, setShowPrintPage, showPrintPage } = useVehiclesContext();

    useEffect(() => {
        if (showPrintPage) {
            window.print();
            setShowPrintPage(false);
        }
    }, [showPrintPage]);
    const groupedVehicles = useMemo(() => groupArray<WeTrackVehicleData["properties"]>(rows, 6), [rows]);

    const getQrValue = useCallback((vehicleId: number) => {
        return `https://transport.elitklinik.io/qr?vehicleId=${vehicleId}&date=${DateTime.now().toFormat("yyyy-MM-dd")}`;
    }, []);
    if (!showPrintPage) {
        return null;
    }

    return (
        <div className="print-content">
            {groupedVehicles.map((item, index) => (
                <div
                    key={index}
                    className=" w-screen  h-screen overflow-hidden bg-white  p-1 grid grid-cols-2 grid-rows-3  max-w-[900px] mx-auto  print:max-w-none"
                >
                    {item.map((item, i) => {
                        return (
                            <div
                                key={i}
                                className={
                                    "flex flex-col gap-2 items-center p-4 pb-2   border-slate-400 border-dashed  justify-center" +
                                    (i % 2 === 0 ? " border-r-2" : "") +
                                    (i < 4 ? " border-b-2" : "")
                                }
                            >
                                <QRCode
                                    value={getQrValue(item.vehicle_id)}
                                    fgColor={colors.elitDarkBlue}
                                    className="h-full w-full"
                                />
                                <PlateComponent plate={item.plate} />
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
};
